export default __webpack_public_path__ + "static/media/screenShots_web-3.11632c84.jpg";